/**
 * The screen every page load starts on, while the server is asked whether this
 * browser is signed in.
 */
export function LoadingScreen() {
  return (
    <div className="screen-loading" data-screen="loading-screen">
      <div className="loader" />
      <p className="loader-text">Validating access...</p>
    </div>
  );
}
